import bindEvent from '../../scripts/util/event/bindEvent';
import isElement from '../../scripts/util/DOM/isElement';
import removeClass from '../../scripts/util/DOM/removeClass';
import addClass from '../../scripts/util/DOM/addClass';
import {forEach, slice} from 'ramda';

const selectors = {
	el: '.js-show-btn',
	content: '.js-show-content',
	wrapper: '.js-show-wrapper',
	item: '.js-show-item'
};

const states = {
	hidden: 'hidden'
};

const text = {
	hide: 'Скрыть'
};

const show = (items, btn) => {
	forEach(removeClass(states.hidden))(items);
	btn.textContent = text.hide;
	btn.dataset.action = 'hide';
};

const hide = (items, btn) => {
	const count = btn.dataset.show;
	forEach(addClass(states.hidden))(items);
	forEach(removeClass(states.hidden))(slice(0, count, items));
	btn.textContent = btn.dataset.text;
	btn.dataset.action = 'show';
};

const toggleView = (action, items, btn) => {
	switch (action) {
		case 'show':
			show(items, btn);
			break;
		case 'hide':
			hide(items, btn);
			break;
		default:
			break;
	}
};

const checkBtn = btn => {
	const count = btn.dataset.show;
	const wrapper = btn.closest(selectors.wrapper);
	const items = wrapper.querySelectorAll(selectors.item);
	const length = items.length;
	if (length <= count) {
		btn.classList.add(states.hidden);
	}
};

const onLoad = () => {
	const btns = document.querySelectorAll(selectors.el);
	forEach(checkBtn)(btns);
};

const onClick = e => {
	const target = e.currentTarget;
	const action = target.dataset.action;
	const wrapper = target.closest(selectors.wrapper);
	const items = wrapper.querySelectorAll(selectors.item);
	toggleView(action, items, target);
};

const setHandlers = () => {
	window.addEventListener('load', onLoad);
	bindEvent(selectors.el, 'click', onClick);
};

const render = () => {
	if (isElement(selectors.el)) {
		setHandlers();
	}
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/education/index.js